import React from 'react';
import { IStyle, mergeStyles } from '@fluentui/react';
import { useCollectionKeys } from '../../../../framework/hooks/collection-keys';
import { IListItem, IListGroup, ListType } from '../../parser/list';

interface IPRIVATE_MarkdownListGroupContentProps {
  items: IListItem[];
}
export const PRIVATE_MARKDOWN_LIST_GROUP_CONTENT: React.FunctionComponent<IPRIVATE_MarkdownListGroupContentProps> = (props) => {
  const { items } = props;
  const itemKeys = useCollectionKeys(items);

  return (
    <>
      {items.map((item, index) => <PRIVATE_MARKDOWN_LIST_ITEM key={itemKeys[index]} {...item} />)}
    </>
  );
};

const getListStyleClass = () => {
  const style: IStyle = {
    fontSize: '1em',
    padding: 0,
    paddingLeft: '2em',
    margin: 0,

    '& li': {
      fontSize: '1em',
      padding: 0,
      margin: '0.5em 0',
      lineHeight: '1.5em',
    },

    '& li img': {
      maxWidth: '100%',
      display: 'block',
      margin: 0,
      marginBottom: '0.5em',
      border: 0,
      padding: 0,
    },

    '& li img:last-child': {
      marginBottom: 0,
    },
  };

  return mergeStyles([ style ]);
}
export const PRIVATE_MARKDOWN_LIST_GROUP: React.FunctionComponent<IListGroup> = (props) => {
  const listStyleClass = getListStyleClass();

  return (
    <>
      {props.itemsType === ListType.Number ?
      <ol className={listStyleClass}>
        <PRIVATE_MARKDOWN_LIST_GROUP_CONTENT items={props.items} />
      </ol>
      :
      <ul className={listStyleClass}>
        <PRIVATE_MARKDOWN_LIST_GROUP_CONTENT items={props.items} />
      </ul>}
    </>
  );
};

export const PRIVATE_MARKDOWN_LIST_ITEM: React.FunctionComponent<IListItem> = (props) => {
  const { groups } = props;
  const groupKeys = useCollectionKeys(groups);

  return (
    <li>
      <div dangerouslySetInnerHTML={{ __html: props.text }}/>
      {groups.map((group, index) => <PRIVATE_MARKDOWN_LIST_GROUP key={groupKeys[index]} {...group} />)}
    </li>
  );
};
